/**
 * @license
 * 
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Define custom blocks.
 * @author samelh@google.com (Sam El-Husseini)
 */

// More on defining blocks:
// https://developers.google.com/blockly/guides/create-custom-blocks/define-blocks


import * as Blockly from 'blockly/core';


Blockly.Blocks['temperatures'] = {
  init: function() {
    this.appendDummyInput()
        .appendField("temperature data");
    this.setOutput(true);
    this.setColour(230);
 this.setTooltip("live temperature data from IOT sensors");
}
}

Blockly.Blocks['humidity'] = {
  init: function() {
    this.appendDummyInput()
        .appendField("humidity data");
    this.setOutput(true);
    this.setColour(230);
 this.setTooltip("live humidity data from IOT sensors");
}
}

Blockly.Blocks['aqi'] = {
  init: function() {
    this.appendDummyInput()
        .appendField("air quality index data");
    this.setOutput(true);
    this.setColour(230);
 this.setTooltip("live aqi data from IOT sensors");
}
}

Blockly.Blocks['graph'] = {
  init: function() {
    this.appendDummyInput()
        .appendField("Graph");
    this.appendValueInput("title")
        .setCheck("String")
        .appendField("title");
    this.appendValueInput("X")
        .setCheck("Array")
        .appendField(new Blockly.FieldTextInput("x-axis"), "X");
    this.appendValueInput("Y")
        .setCheck("Array")
        .appendField(new Blockly.FieldTextInput("y-axis"), "Y");
    this.setColour(90);
 this.setTooltip("Create a scatter plot of lists X and Y");
 this.setHelpUrl("");
 this.setPreviousStatement(true, null);
  this.setNextStatement(true, null);
  }
};